// extracted by mini-css-extract-plugin
export default {"statusBox":"AdminMoblieUserList_statusBox__aw9jo","modifyBtn":"AdminMoblieUserList_modifyBtn__hzrw6","deleteBtn":"AdminMoblieUserList_deleteBtn__qXcC4"};